import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React from 'react';
import classnames from 'classnames';
import Dumbo from '../../Dumbo';
import FooterPanel, { FOOTER_PANEL_HEIGHT } from '../../Helper/FooterPanel';
import StackOverlay from './_partials/StackOverlay';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../_helpers';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './Stack.scss';
const STACK_INDICATOR_HEIGHT = parseInt(s['stack-indicator-height']);
const Stack = ({ deviation , width , height , className , url , style , biData , onRemove , onClick  })=>{
    const dumboHeight = height ? height - (FOOTER_PANEL_HEIGHT + STACK_INDICATOR_HEIGHT) : undefined;
    const linkAsWrapper = [
        DeviationTypes.IMAGE,
        DeviationTypes.FILM,
        DeviationTypes.PDF
    ].includes(getDeviationType(deviation));
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], deviation.hasNewContent && s['unread'], className),
        style: _object_spread_props(_object_spread({}, style), {
            width,
            height
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['stack-indicator']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['stack-indicator-inner']
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['content-wrapper']
    }, linkAsWrapper && /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['content'],
        href: url,
        onClick: onClick,
        biData: biData
    }, /*#__PURE__*/ React.createElement(Dumbo, {
        deviation: deviation,
        width: width,
        height: dumboHeight
    })), !linkAsWrapper && /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, /*#__PURE__*/ React.createElement(Dumbo, {
        deviation: deviation,
        width: width,
        height: dumboHeight
    }), /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        href: url,
        onClick: onClick,
        className: s['link-overlay'],
        biData: biData
    })), /*#__PURE__*/ React.createElement(StackOverlay, {
        deviation: deviation,
        url: url,
        onRemove: onRemove,
        onClick: onClick,
        biData: biData,
        className: s['overlay']
    }), /*#__PURE__*/ React.createElement(FooterPanel, {
        deviation: deviation
    })));
};
Stack.displayName = 'StackThumb';
export default Stack;
export const SIZE_ADJUSTMENTS = FOOTER_PANEL_HEIGHT + STACK_INDICATOR_HEIGHT;
